.delta {
  display: inline-flex;
  align-items: baseline;
  gap: var(--space-1);
  font-family: var(--font-sans);
  font-weight: var(--weight-semi);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.sm {
  font-size: var(--text-sm);
}

.md {
  font-size: var(--text-base);
}

.arrow {
  font-size: 0.75em;
  line-height: 1;
}

.suffix {
  color: var(--text-muted);
  font-weight: var(--weight-medium);
}

.good {
  color: var(--color-success);
}

.bad {
  color: var(--color-danger);
}

.flat {
  color: var(--text-muted);
}
